import { useState } from "react";
import swal from "sweetalert";
import useDelete from "./useDelete";
import { useNavigate } from "react-router-dom";
import useGenerateQr from "./useGenerateQr";

const useTable = () => {
  const navigate = useNavigate();
  const { isLoading, error, handleDelete } = useDelete();
  const { isLoadingGenerate, errorGenerate, handleGenerate } = useGenerateQr();

  const [dataRemove, setDataRemove] = useState([]);

  const handleRemove = (props) => {
    swal({
      text: "Deleted data will disappear from the system",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (!willDelete) return;

      const dataDelete = [];

      dataRemove.forEach((data) => {
        const id = data._id ?? data.id ?? data.user_id;

        if (!id) {
          console.error("❌ INVALID ROW SELECTED:", data);
          return;
        }

        dataDelete.push(id);
      });

      // 🚫 STOP kalau tidak ada ID valid
      if (dataDelete.length === 0) {
        swal("Error", "Invalid data selected", "error");
        return;
      }

      let deleteUrl = props.url;
      let deleteForm = null;

      if (dataDelete.length === 1) {
        deleteUrl = `${props.url}/${dataDelete[0]}`;
      } else {
        deleteForm = { id: dataDelete };
      }

      handleDelete({
        url: deleteUrl,
        descSuccess: props.descSuccess,
        form: deleteForm,
      });
    });
  };

  // const handleGenerateQr = (props) => {
  //   // swal({
  //   //   text: "Generate data will disappear from the system",
  //   //   icon: "warning",
  //   //   buttons: true,
  //   //   dangerMode: true,
  //   // }).then((willDelete) => {
  //   //   if (willDelete) {
  //   let dataGenerate = [];
  //   dataRemove.map((data) => {
  //     dataGenerate.push(data._id);
  //     // if (data.user_id) {
  //     //   dataGenerate.push(data.user_id);
  //     // } else {
  //     //   dataGenerate.push(data._id);
  //     // }
  //   });

  //   let params = {
  //     url: props.url,
  //     descSuccess: props.descSuccess,
  //     form: {
  //       id: dataGenerate,
  //     },
  //   };

  //   handleGenerate(params);
  //   // }
  //   // });
  // };

  const handleSelected = ({ selectedRows }) => {
    setDataRemove(selectedRows);
  };

  const handleEdit = (url) => {
    navigate(url, { state: dataRemove[0] });
  };

  const handleGenerateQr = (url) => {
    //Dipakai

    navigate(url, { state: dataRemove });
    // // swal({
    // //   text: "Generate data will disappear from the system",
    // //   icon: "warning",
    // //   buttons: true,
    // //   dangerMode: true,
    // // }).then((willDelete) => {
    // //   if (willDelete) {
    // let dataGenerate = [];
    // dataRemove.map((data) => {
    //   dataGenerate.push(data._id);
    //   // if (data.user_id) {
    //   //   dataGenerate.push(data.user_id);
    //   // } else {
    //   //   dataGenerate.push(data._id);
    //   // }
    // });

    // let params = {
    //   url: props.url,
    //   descSuccess: props.descSuccess,
    //   form: {
    //     id: dataGenerate,
    //   },
    // };

    // handleGenerate(params);
    // // }
    // // });
  };

  return {
    isLoading,
    error,
    dataRemove,
    handleEdit,
    handleGenerateQr,
    handleRemove,
    handleSelected,
  };
};

export default useTable;
